import { useEffect } from "react";

const useMetaPixel = ({ metaPixelId }: { metaPixelId: string | undefined }) => {
    useEffect(() => {
        if (window.fbq) {
            console.log(
                "Meta tracking pixel is already initialized. Skipping initialization."
            );
            return;
        }

        if (metaPixelId) {
            console.log(
                "Initializing Meta tracking pixel with id = ",
                metaPixelId
            );

            /**
             * Create a <script> tag that loads the Meta tracking pixel.
             *
             * See: https://developers.facebook.com/docs/meta-pixel/get-started/#base-code
             */
            const script = document.createElement("script");
            script.innerHTML = `
                !function(f,b,e,v,n,t,s)
                {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                n.queue=[];t=b.createElement(e);t.async=!0;
                t.src=v;s=b.getElementsByTagName(e)[0];
                s.parentNode.insertBefore(t,s)}(window, document,'script',
                'https://connect.facebook.net/en_US/fbevents.js');
                fbq('init', '${metaPixelId}');
                fbq('track', 'PageView');
            `;
            script.id = "meta-pixel-script";
            document.head.appendChild(script);

            return () => {
                document.head.removeChild(script);
            };
        } else {
            console.log(
                "Meta tracking pixel id is not set. Skipping initialization."
            );
        }
    }, [metaPixelId]);
};

const trackWithMetaPixel = (
    eventName: string,
    eventAction: string,
    parameters?: Record<string, unknown>
) => {
    if (window.fbq) {
        window.fbq(eventName, eventAction, parameters);
    } else {
        console.warn(
            "Meta tracking pixel is not initialized. Cannot track event."
        );
    }
};

export { useMetaPixel, trackWithMetaPixel };
